var map = {
	"./All_Stations.png": 8957,
	"./AnimationOff.png": 5056,
	"./AnimationOn.png": 2291,
	"./Buoy_Station.png": 5498,
	"./Crosshair.png": 6390,
	"./Current_Station.png": 3001,
	"./HakaiLogo.png": 418,
	"./Instagram_Glyph_White.svg": 7062,
	"./Marker.png": 7404,
	"./Stations_hidden.png": 6064,
	"./Tide_Station.png": 9922,
	"./Weather_Station.png": 3990,
	"./WebcamIcon.png": 5043,
	"./Webcam_Station.png": 5416,
	"./X-logo-white.svg": 4266,
	"./air.temperature.svg": 6907,
	"./backgroundNoDataPattern.png": 4704,
	"./colorDataDisabled.png": 7844,
	"./colorDataEnabled.png": 3537,
	"./currents.svg": 3119,
	"./direction_arrow.svg": 652,
	"./forecastOff.png": 4095,
	"./forecastOn.png": 1707,
	"./logo_text.png": 366,
	"./logo_text.svg": 1241,
	"./metaLogo.png": 9672,
	"./moon.svg": 5470,
	"./ocean.temperature.svg": 3844,
	"./oceanconnectlogo-color-02.svg": 2384,
	"./oceanconnectlogo-color-03.svg": 8378,
	"./oceanconnectlogo-color-04.svg": 8599,
	"./oceanconnectlogo-color-05.svg": 9995,
	"./oceanconnectlogo-color-06.svg": 5783,
	"./oceanconnectlogo-color-07.svg": 0,
	"./oceanconnectlogo-color-11.svg": 4398,
	"./oceanconnectlogo-color-12.svg": 6558,
	"./oceanconnectlogo-horiz-white.svg": 5632,
	"./oceanconnectlogo-large.png": 8180,
	"./sailboat.png": 8747,
	"./sun-day.svg": 4123,
	"./tides.svg": 4473,
	"./waves.svg": 3666,
	"./weather.svg": 8304,
	"./webcam.svg": 813,
	"./wind.svg": 4303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 252;